import Vue from "vue";
import { removeEmptyKeys } from "../../../../../shared/utils/utils";
import { getMainApi, postClientsApi, getClientsApi, postMainApi } from "../../../../../shared/utils/ajax";
// import NewApplicationSchema from "@Shared/@DataFiles/new-app-schema.json";

export const getApplication = async (applicationId, agentUsername = null, newBrokerageId = null) => {
  const endpoint = `/application/${applicationId}`;
  return await getClientsApi({
    agentUsername
  }, endpoint, newBrokerageId);
};
export const updateApplication = async (rawApplication, applicationId, changes = {}, newBrokerageId = null) => {
  const application = removeEmptyKeys(rawApplication);
  const endpoint = `/application/${applicationId}`;
  return postClientsApi({
    application,
    changes
  }, endpoint, newBrokerageId);
};
export const submitApplication = async (consentObtained, acceptedConsents, applicationId, flow, additionalInformation = "", newBrokerageId = null) => {
  const subdomain = location.pathname.replace("/", "");
  const endpoint = `/application/${applicationId}/submit?subdomain=${subdomain}`;
  return postClientsApi({
    consentObtained,
    acceptedConsents,
    additionalInformation,
    flow
  }, endpoint, newBrokerageId);
};
export const getDisclaimers = async () => {
  const subdomain = location.pathname.replace("/", "");
  const endpoint = `/account/disclaimer?subdomain=${subdomain}`;
  return getClientsApi({}, endpoint);
};
export const getSchema = async subdomain => {
  // return getLocal("new-schema");
  subdomain = subdomain || location.pathname.replace("/", "");
  return getClientsApi({}, `/account/application-form?subdomain=${subdomain}`);
};
export const getCustomizationSchema = async subdomain => {
  // return NewApplicationSchema
  subdomain = subdomain || location.pathname.replace("/", "");
  return getClientsApi({
    subdomain,
    newApplication: true
  }, `/account/application-form`);
};
export const getFullSIN = async (refId, applicationId) => {
  const session = Vue.auth.session.get();
  const brokerageId = session.brokerageDetails.tiedBrokerages[0].brokerageId;
  const endpoint = `/brokerage/${brokerageId}/application/${applicationId}/secure-data/${refId}`;
  return getMainApi({}, endpoint);
};
export const createNewApplication = async (subdomain, brokerageId, fromClient) => {
  const endpoint = `/new-app`;
  return postMainApi({
    brokerageId,
    subdomain,
    fromClient
  }, endpoint);
};
export const getApplicationValidations = async applicationId => {
  return postMainApi({}, `/application/${applicationId}/validate`);
};
export const getApplicationsFromSubdomain = async subdomain => {
  return getClientsApi({
    subdomain
  }, "/application");
};